import { Link } from "react-router-dom";

export const LEGAL_LINKS = [
  { to: "/legal/terms", label: "Terms of Use" },
  { to: "/legal/privacy", label: "Privacy Policy" },
  { to: "/legal/acceptable-use", label: "Acceptable Use" },
  { to: "/legal/contact", label: "Contact" },
];

export const LEGAL_DISCLAIMER =
  "FindRxStaff is a technology platform that helps pharmacies and pharmacy professionals connect regarding staffing opportunities. Users are responsible for independently verifying qualifications, compensation, schedules, and working arrangements. FindRxStaff does not provide legal, employment, tax, or professional advice.";

export default function SiteFooter({ compact = false }) {
  return (
    <footer className={`border-t border-slate-200 bg-white ${compact ? "mt-16" : ""}`} data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6">
        {!compact && (
          <span className="font-display text-base font-semibold text-slate-900">FindRxStaff</span>
        )}
        <p className="mt-2 max-w-3xl text-sm leading-relaxed text-slate-500">{LEGAL_DISCLAIMER}</p>
        <p className="mt-3 text-sm text-slate-500">
          FindRxStaff is currently free to use. Pricing and features may change in the future, subject to
          updated terms and appropriate notice.
        </p>
        <nav className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-sm">
          {LEGAL_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="font-medium text-brand hover:underline"
              data-testid={`footer-${l.to.split("/").pop()}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <p className="mt-5 text-xs text-slate-400">
          findrxstaff.com · Do not submit patient information, PHI, prescriptions, passwords or financial
          account details to this platform.
        </p>
      </div>
    </footer>
  );
}
